export default "__VITE_ASSET__101f2948__"